import { SellerOnboardingStepType } from '../../models/ClientModels';
import { StepInfo } from './types';

export const kDefaultMinimumInventoryListingCount = 20;
export const kDefaultMinimumPublicListingCount = 10;

export const kStepsInfo: { [key in SellerOnboardingStepType]: StepInfo } = {
  [SellerOnboardingStepType.PslPay]: {
    type: SellerOnboardingStepType.PslPay,
    url: '_pslPaySetupNotice',
  },
  [SellerOnboardingStepType.StoreInfo]: {
    type: SellerOnboardingStepType.StoreInfo,
    url: '_storeInfo',
  },
  [SellerOnboardingStepType.StoreReel]: {
    type: SellerOnboardingStepType.StoreReel,
    url: '_storeReel',
  },
  [SellerOnboardingStepType.BusinessLocation]: {
    type: SellerOnboardingStepType.BusinessLocation,
    url: '_seller_businessLocation',
  },
  [SellerOnboardingStepType.ShippingOptions]: {
    type: SellerOnboardingStepType.ShippingOptions,
    url: '_shippingOptions',
  },
  [SellerOnboardingStepType.Inventory]: {
    type: SellerOnboardingStepType.Inventory,
    url: '_creatorInventoryNotice',
  },
  [SellerOnboardingStepType.Storefront]: {
    type: SellerOnboardingStepType.Storefront,
    url: '_storefrontListings',
  },
  [SellerOnboardingStepType.CommentChat]: {
    type: SellerOnboardingStepType.CommentChat,
    url: 'setupCommentChat',
  },
};
